/**
 * The downhole field writes are not queued offline. Checked before a write is
 * sent, so a hand in a dead zone is told plainly that nothing was saved rather
 * than waiting on a request that cannot arrive. True means "go ahead".
 */
export function onlineOrSay(say: (message: string) => void): boolean {
  if (typeof navigator !== 'undefined' && navigator.onLine === false) {
    say('You are offline. Nothing was saved. Try again when you have signal.');
    return false;
  }
  return true;
}
